// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useCallback } from 'react';
import { useComboboxDropdown } from './useComboboxDropdown';
export function useCombobox({ comboboxRef, comboboxPopoverRef, options = [], value = null, isComboboxItemMode = false, autoFocus = false, onValueChange, onClose }) {
    const selectedValue = isComboboxItemMode && value !== null ? value.value : value;
    const selectedItem = options.find((item) => item.value === selectedValue);
    const { isOpened, dropdownPosition, dropdownMinWidth, generateKey, toggleOpen, setIsOpened } = useComboboxDropdown({
        comboboxRef,
        comboboxPopoverRef,
        autoFocus,
        onClose
    });
    const onSelect = useCallback((item) => {
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(isComboboxItemMode ? item : item.value);
        setIsOpened(false);
    }, [isComboboxItemMode, onValueChange, setIsOpened]);
    return {
        isOpened,
        selectedValue,
        selectedItem,
        dropdownPosition,
        dropdownMinWidth,
        toggleOpen,
        generateKey,
        onSelect
    };
}
